var _a;
import { utilArray } from "../utils/utilArray";
import { IdWalkingCitizens } from "./IdWalkingCitizens";
export var WalkingCitizenConfiguration = (_a = {},
    _a[IdWalkingCitizens.Boy] = ["boy_idle", "boy_idle_break", "boy_walk_6x6"],
    _a[IdWalkingCitizens.Girl] = ["girl_idle", "girl_walk_6x6"],
    _a[IdWalkingCitizens.Man] = ["guy_idle_wave", "guy_walk_6x6", "guy_walk_6x6_B"],
    _a[IdWalkingCitizens.Woman] = ["lady_idle", "lady_walk_6x6", "lady_walk_6x6_B"],
    _a);
export var getRandomIdWalkingCitizen = function () {
    var citizenTypes = Object.keys(WalkingCitizenConfiguration);
    return utilArray.getRandomElement(citizenTypes);
};
export var getRandomWalkingCitizenAnimation = function (id) {
    var animationTypes = WalkingCitizenConfiguration[id];
    var animationTypeLength = animationTypes.length;
    return animationTypes[Math.floor(Math.random() * animationTypeLength)];
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/WalkingCitizenConfiguration.ts
// module id = 2202
// module chunks = 3